import { render } from "./main-menu.vue?vue&type=template&id=195921f7"
import script from "./main-menu.vue?vue&type=script&lang=js"
export * from "./main-menu.vue?vue&type=script&lang=js"

import "./main-menu.vue?vue&type=style&index=0&id=195921f7&lang=postcss"
script.render = render

export default script